import React, { ReactNode } from "react";
import { createClasses } from "@bloomberg/media-ui-core";

import styles from "./styles.module.css";

/**
 * Alignment variants for a ZoneColumn
 */
export type ZoneColumnVariant = "full" | "left" | "right";

export interface ZoneColumnProps {
  columnId?: string;
  variant: ZoneColumnVariant;
  fillEmptySpace?: boolean;
  className?: string;
  children?: ReactNode;
}

/**
 * ZoneColumn is a child section within a ZoneContainer.
 * It supports different alignment variants and exposes data attributes
 * for hooks or styling.
 */
export const ZoneColumn: React.FC<ZoneColumnProps> = ({
  columnId = "zone_column",
  fillEmptySpace = false,
  variant,
  className,
  children,
}) => {
  const cx = createClasses([
    styles.zoneColumn,
    className,
    {
      [styles.fillEmptySpace]: fillEmptySpace,
    },
  ]);

  return (
    <section
      data-column-id={columnId}
      data-column-variant={variant}
      data-component="zone-column"
      className={cx}
    >
      {children}
    </section>
  );
};
